<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
    <div class="main-navbar">
      <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
        <a class="navbar-brand w-100 mr-0" href="#" style="line-height: 25px;">
          <div class="d-table m-auto">
            <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 110px;" src="@/assets/images/headwear.jpg" alt="HeadWear CRM">
          </div>
        </a>
        <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>

      <div class="d-flex">
        <div class="logged-in-as text-center">
          <small>{{ $t('users.loggedInAs') }}:</small><br>
          <small class="text-primary">{{ getUserEmail }}</small>
        </div>
      </div>
    </div>

    <div class="nav-wrapper">
      <d-nav class="flex-column">
        <li
          v-for="(item, navItemIdx) in items"
          :key="navItemIdx"
          class="nav-item dropdown">
          <d-link :class="['nav-link', 'd-flex', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`">
            <div class="item-icon-wrapper" v-if="item.htmlBefore" v-pure-html="item.htmlBefore" />
            <span v-if="item.title">{{ item.title[currentLanguage] }}</span>
            <div class="item-icon-wrapper" v-if="item.htmlAfter" v-pure-html="item.htmlAfter" />
          </d-link>
          <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
            <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
              {{ subItem.title[currentLanguage] }}
            </d-dropdown-item>
          </d-collapse>
        </li>
      </d-nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';
import getPrefferedLanguage from './../../../utils/i18nUtils.js';

export default {
  name: 'main-sidebar',
  props: {
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'getUserEmail'
    ]),
    currentLanguage () {
      return getPrefferedLanguage();
    }
  },
  data() {
    return {
      sidebarVisible: false,
    };
  },
  created() {
    this.$bus.$on('toggle-sidebar', this.handleToggleSidebar);
  },
  beforeDestroy() {
    this.$bus.$off('toggle-sidebar');
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    }
  }
};
</script>

<style lang="scss">
.main-sidebar {
  min-width: 220px;

  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }

  .nav-wrapper {
    height: calc(100vh - 3.75rem - 1px - 60px)!important;
  }
}

.logged-in-as {
  background: #f5f5f5;
  border-bottom: 1px solid #e1e5eb;
  line-height: 1.2;
  padding: 10px;
  width: 100%;
}

.product-search {
  background: #f5f5f5;
  border-bottom: 1px solid #e1e5eb;
  border-right: 1px solid #e1e5eb;
  cursor: pointer;
  line-height: 1.2;
  padding: 10px;
  text-align: center;
  width: 60px;

  i {
    font-size: 32px;
  }

  & + .logged-in-as {
    width: calc(100% - 60px);
  }

  &:hover {
    background: #e1e5eb;
  }
}
</style>
